import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class RouteReusableStrategy extends RouteReuseStrategy {
  public shouldDetach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  public store(_route: ActivatedRouteSnapshot, _detachedTree: DetachedRouteHandle | null): void {} // NOSONAR - required RouteReuseStrategy hook; routes are never detached by this strategy.

  public shouldAttach(_route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  public retrieve(_route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return null;
  }

  public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig || future.data.reuse;
  }
}
